var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgByRoad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "by-road",
    transform: "translate(-457 -1375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    transform: "translate(457 1375)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MDI_highway",
    "data-name": "MDI / highway",
    transform: "translate(462 1380)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_highway",
    "data-name": "Path / highway",
    d: "M9.9,2,7.922,7.922h2.961V2H9.9m2.961,0V7.922h2.961L13.845,2h-.987M2,8.91V9.9H3.974v.987H5.948V9.9H17.793l.059.987h1.915V9.9h1.974V8.91H2m4.935,1.974L3.323,21.742h7.561V10.884H6.935m5.922,0V21.742h7.561L16.806,10.884Z",
    transform: "translate(0.749 0.749)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgByRoad);
export default __webpack_public_path__ + "static/media/by-road.9d13e2076d93ac35f909cbb633b4c6eb.svg";
export { ForwardRef as ReactComponent };